import React, { Component } from 'react';
import 'react-image-gallery/styles/css/image-gallery.css';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CardHeader from '@material-ui/core/CardHeader';
import Card from '@material-ui/core/Card';
import Paper from '@material-ui/core/Paper';

import { getReport } from '../../../api/api';
import ResortLocation from './ResortLocation';
import Photos from './Photos';
import ResortServices from './ResortServices';
import bg from './bg.png';
import './Gallery.css';
import './Review.css';
import { Grid } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import classNames from 'classnames';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { NavLink } from "react-router-dom";
import Vector2 from '../../../assets/images/Vector2.png';

// https://pixabay.com/ru/%D0%BF%D0%B5%D0%BD%D0%B8%D0%B5-%D0%B4%D0%B5%D1%82%D0%B8-%D1%80%D0%B5%D0%B1%D0%B5%D0%BD%D0%BE%D0%BA-%D0%B3%D1%80%D1%83%D0%BF%D0%BF%D0%B0-%D0%BF%D0%B5%D1%82%D1%8C-304617/

function TabContainer({ children }) {
  return (
    <Typography component="div" style={{ padding: 8 * 1 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  media: {
    minHeight: 'auto',
    width: '50%',
    margin: '0 auto',
    textAlign: 'center',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  root: {
    padding: 0,
    height: 'auto',
    minHeight: '55vh',
    backgroundColor: '#e9ebee',
    // background: "linear-gradient(to top,rgba(7,177,197,0), rgba(189,223,200,0.4))",

    textColor: {
      color: green[500],

    },
    tabsIndicator: {
      backgroundColor: 'grey',
      [theme.breakpoints.down('sm')]: {
        fontSize: '10',
      },
    },
    tabsFont: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '10',
      },
    },
    tabRootButton: {
      minHeight: 'unset !important',
      minWidth: 'unset !important',
      width: 'unset !important',
      height: 'unset !important',
      maxWidth: 'unset !important',
      maxHeight: 'unset !important',
      padding: '10px 15px',
      borderRadius: '3px',
      lineHeight: '24px',
      border: '0 !important',
      color: '#fff !important',
      marginLeft: '4px',
      '&:last-child': {
        marginLeft: '0px',
      },
    },
    //  ...customTabsStyle
   
  },
  headerConteyner: {
    width: '90%',
    display: 'flex',
    margin: '70px auto 30px',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      width: '100%',
    },
  },
  navButton: {
    width: '20%',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginBottom: '25px',
      textAlign: 'left',
    },
  },
  titleSection: {
    width: '90%',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
   
  },
  titleFirst: {
    color: '#0A0A13',
    fontFamily: 'Inter',
    fontSize: '33px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '120%',
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  buttonBack: {
  color: '#595959',
  fontFamily: 'Inter',
  fontSize: '20px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '120%',
  letterSpacing: '-0.6px',
  },
  icon: {
    marginRight: '15px',
  },
  mobBlock:{
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'space-around',
      width: '100%',
    },
  },
  mobVerif:{
    [theme.breakpoints.down('sm')]: {
      width: '35%',
      fontSize: '12px',
    },
  },
  mobSubTitle:{
    fontSize: '20px',
    [theme.breakpoints.down('sm')]: {
      width: '58%',
      fontSize: '12px',
    },
  },
});

const StyledTabs = withStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  indicator: {
    display: 'none',
  },
  section: {
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    padding: '70px 0',
  },
  textCenter: {
    textAlign: 'center',
  },
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    minHeight: 'unset',
    minWidth: 'unset',
    width: 'unset',
    height: 'unset',
    maxWidth: 'unset',
    maxHeight: 'unset',
    padding: '10px 15px',
    marginLeft: '4px',
    color: '#2F4960',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    borderRadius: '600px',
    border: '2px solid  #175E82',
    margin: '0 15px',
    letterSpacing: '0.24px',
    '&:last-child': {
      marginLeft: '0',
    },
  },
  labelContainer: {
    padding: '0',
  },
  label: {

    color: '#2F4960',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    letterSpacing: '0.24px',
  },
  selected: {
    // backgroundColor: 'rgba(0, 0, 0, 0.1)',
    backgroundColor: '#175E82',
    color: 'white',
    borderRadius: '600px',
    border: '2px solid  #175E82',
  },
  wrapper: {
    display: 'inline-block',
    minHeight: 'unset',
    minWidth: 'unset',
    width: 'unset',
    height: 'unset',
    maxWidth: 'unset',
    maxHeight: 'unset',
    '& > svg': {
      verticalAlign: 'middle',
      marginRight: '5px',
    },
  },
}))((props) => <Tab disableRipple {...props} />);

class Review extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      data: null,
      loading: false,
    };
  }

  componentDidMount() {
    //  console.log(this.props.id);
    this.setState({
      loading: true,
    });
    getReport(this.props.match.params.id)
      .then((response) => {
        // console.log(response)
        this.setState({
          data: response.data,
        });
      })
      .catch(() => {})
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  handleChange = (_, value) => {
    this.setState({ value });
  };

  render() {
    const { value, loading } = this.state;
    const { classes,
       headerColor, tabs, title,
    } = this.props;

    return (
      <section className="review">
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        
        <div className="container-fluid mt-2">
          
          <div className={classes.headerConteyner}>
              <div className={classes.navButton}>
              <NavLink
            to="/mop/search"
            style={{ textDecoration: "none" }}
            activeStyle={{
              border: "1px solid #fff",
            }}
          >
            <span className={classes.buttonBack}>
            <img className={classes.icon} src={Vector2} />
              Назад до пошуку
              
            </span>
          </NavLink>
              </div>
              <div className={classes.titleSection}>
             <p className={classes.titleFirst}> {((this.state.data || {}).mapMo || {}).P_3} </p>

          <div className={classes.mobBlock}>
            <div className={classes.mobVerif}>
             {((this.state.data || {}).mapMo || {}).P_50 === 1 ? (
                            <h4 style={{ color: 'green' }}>Верифіковано</h4>
                          ) : ((this.state.data || {}).mapMo || {}).P_50
                            === 0 ? (
                              <p style={{ color: 'red' }}>Не верифіковано </p>
                            ) : ((this.state.data || {}).mapMo || {}).P_50
                            === null ? (
                              <p style={{ color: '#FFD700' }}>
                                Немає верифікації
                                {' '}
                              </p>
                              ) : null}
                          </div>
                          <div className={classes.mobSubTitle}>
                          {/* <p>{((this.state.data || {}).mapMo || {}).c_verified_text} </p> */}
                          <p>
                            {((this.state.data || {}).mapMo || {}).P_51}
                            {' '}
                          </p>
                          </div>
                    </div>
              </div>

            </div>
            {/* <CardHeader
            title={( */}
           
            
              
                 {/* <div className="container justify-content-center">
                  <Grid justify="center">
                    <Grid item xs={12} sm={12} md={12}>

                       <div className={classes.profile}>
                        <div className={`${classes.name} text-center`}>
                          <h3 className={classes.title}>
                            {((this.state.data || {}).mapMo || {}).P_3}
                          </h3>

                          {((this.state.data || {}).mapMo || {}).P_50 === 1 ? (
                            <h4 style={{ color: 'green' }}>Верифіковано</h4>
                          ) : ((this.state.data || {}).mapMo || {}).P_50
                            === 0 ? (
                              <p style={{ color: 'red' }}>Не верифіковано </p>
                            ) : ((this.state.data || {}).mapMo || {}).P_50
                            === null ? (
                              <p style={{ color: '#FFD700' }}>
                                Немає верифікації
                                {' '}
                              </p>
                              ) : null}
                          <p style={{ fontSize: '20px' }}>
                            {((this.state.data || {}).mapMo || {}).P_51}
                            {' '}
                          </p>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                 </div>
               )}
             /> */}

            {/* <CardMedia
          className={classes.media}
          component="img"
          alt="Contemplative Reptile"
          src={`/mop/${bg}`}
          title="Contemplative Reptile"
        /> */}
<Card>
            <CardContent className={classes.root}>
              <div className="row justify-content-center">
                <div className="col-md-6">
                  {/* <Paper style={{ background: 'linear-gradient(to right, #D7F64D, #89DB33' }}> */}
                  <Paper style={{ background: '#e9ebee' }}>
                    <StyledTabs
                      centered
                      variant="fullWidth"
                      value={value}
                      onChange={this.handleChange}
                      // indicatorColor="primary"
                      // className={classes.textColor}
                    >
                      {/* <Tab label="Заклад" /> */}
                      <StyledTab
                        label={<span className="label">Заклад</span>}
                      />
                      <StyledTab
                        label={<span className="label">Галерея</span>}
                      />
                      <StyledTab
                        label={<span className="label">Контакти</span>}
                      />
                    </StyledTabs>
                  </Paper>
                </div>
                <div className="col-md-10">
                  {value === 0 && (
                    <TabContainer>
                      {' '}
                      {this.state.data && (
                        <ResortServices
                          mapMo={this.state.data ? this.state.data.mapMo : ''}
                          lics={this.state.data ? this.state.data.lics : ''}
                        />
                      )}
                      {' '}
                    </TabContainer>
                  )}
                  {value === 1 && (
                    <TabContainer>
                      <Photos
                        photos={this.state.data ? this.state.data.photos : []}
                      />
                    </TabContainer>
                  )}
                  {value === 2 && (
                    <TabContainer>
                      <ResortLocation
                        mapMo={this.state.data ? this.state.data.mapMo : ''}
                      />
                    </TabContainer>
                  )}

                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    );
  }
}

export default withStyles(styles)(Review);
